<template>
    <el-dropdown trigger="click" @command="changeLang">
        <span class="el-dropdown-link flex-level cpointer">
            <img :src="`/ressources/public/img/flags/lang/${currentLang.id}.png`" class="pr-2" />
            <span>{{ currentLang.label }}</span>
            <i class="icon-chevron-bottom ml-3 gray-60"></i>
        </span>
        <template #dropdown>
            <el-dropdown-menu>
                <el-dropdown-item
                    v-for="(lang, langKey) in languages"
                    :key="langKey"
                    :command="lang.id"
                    class="flex-level"
                >
                    <img :src="`/ressources/public/img/flags/lang/${lang.id}.png`" class="pr-2" />
                    <span>{{ lang.label }}</span>
                </el-dropdown-item>
            </el-dropdown-menu>
        </template>
    </el-dropdown>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState } = createNamespacedHelpers('system');

export default {
    props: {
        modelValue: {
            type: String,
            required: true,
        },
        availableLanguages: {
            type: Array,
            required: false,
            default: () => [],
        },
    },
    computed: {
        ...mapState({
            allLanguages: 'availableLanguages',
        }),
        languages() {
            return this.availableLanguages.length > 0
                ? this.allLanguages.filter((language) =>
                    this.availableLanguages.includes(language.id),
                )
                : this.allLanguages;
        },
        currentLang() {
            return this.languages.find((lang) => lang.locale === this.modelValue);
        },
    },
    methods: {
        changeLang(lang) {
            window.LocalizationHelpers.changeLanguage(lang);
        },
    },
};
</script>
